import React, {useState} from 'react';
import "../Styles/fontawesome-free-5.15.3-web/css/all.css";
import "../Styles/SymbolMatching.css";

// props:
// onCompletion: callback
// demo: boolean indicating whether this is demo mode
// refs: array of functions that control the tutorial
// tutorialOngoing: boolean indicating the tutorial is still going
export default function SymbolMatchingPlayerTable(props) {

    const symbols = [
        'fas fa-circle',
        'fas fa-share-alt',
        'fas fa-snowflake',
        'fas fa-square',
        'fas fa-star',
        'fas fa-lightbulb',
        'fas fa-lock',
        'fas fa-play',
        'fas fa-hourglass'
      ]

    const tooltipProps = {
        'data-tip': 'tooltip',
        'data-event': 'show',
        'data-scroll-hide': 'false'
    }

    const SPACES = 9;

    const [currentQuestion, setCurrentQuestion] = useState(0); // current index in table
    const [filledValues, setFilledValues] = useState(Array(9).fill("")); // symbols filled in already
    const [completed, setCompleted] = useState(false); // if game completed
    const [numCorrect, setNumCorrect] = useState(0); // tracks number correct

    const [orderOfSymbols, setOrderOfSymbols] = useState([]); // ints keeps symbol ordering 
    const [round, setRound] = useState(0); // tracks round number

    
     // does the inital shuffling, based on the props passed in

     const seq = [
        1,8,9,7,6,5,4,3,2,1,4,8,3,2,9,6,7,5,8,6,2,1,9,7,4,3,5,
        7,9,3,8,5,4,1,6,2,4,6,2,5,3,8,7,9,1,6,7,5,8,6,2,1,9,7,
        4,3,5,7,9,3,8,5,4,1,6,2,4,6,2,5,3,8,7,9,1,6,7,5,8,6,2,
        1,9,7,4,3,5,7,9,3,8,5,4,1,6,2,4,6,2,5,3,8,7,9,1,6,7,5,
        8,6,2,1,9,7,4,3,5,7,9,3,8,5,4,1,6,2,4,6,2,5,3,8,7,9,1,
        6,7,5,8,6,2,1,9,7,4,3,5,7,9,3,8,5,4,1,6,2,4,6,2,5,3,8,
        7,9,1,6,7,5,8,6,2,1,9,7,4,3,5,7,9,3,8,5,4,1,6,2,4,6,2,
        5,3,8,7,9,1,6,7,5,8,6,2,1,9,7,4,3,5,7,9,3,8,5,4,1,6,2,
        4,6,2,5,3,8,7,9,1
    ];

     React.useEffect(() => {
        if (orderOfSymbols.length !== 0) {
            return;
        }

        // shuffles the index values
        let newShuffleIndices = []
        if (!props.demo) {
            let startingIndex = (round * SPACES) % seq.length;
            let endingIndex = (round * SPACES + SPACES)
            if(endingIndex > seq.length){
                setCompleted(true)
                props.onCompletion();
                endingIndex = 0
            }
            newShuffleIndices = seq.slice(startingIndex, endingIndex);
        } else {
            newShuffleIndices = [5,9,6,1,5,2,7,3,8]
        } 

        setOrderOfSymbols(newShuffleIndices)
    }, [orderOfSymbols.length, props.demo, round]);

    React.useEffect(() => {
          // sets timer for the length of the symbol matching game 
          if (!props.demo) {
            const timer = setTimeout(() => {
                setCompleted(true);
                props.onCompletion();
            }, 90*1000);
            return () => clearTimeout(timer); 
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    function buttonOnClick(index) {
        // sets the symbol to fill in
        let newFilledValues = [...filledValues];
        newFilledValues[currentQuestion] = symbols[index];
        setFilledValues(newFilledValues);
        setCurrentQuestion(currentQuestion + 1); 

        let enteredText = symbols[index];
        let answer = symbols[orderOfSymbols[currentQuestion]-1]

        // checks if correct
        if (symbols[index] === symbols[orderOfSymbols[currentQuestion]-1]) {
            console.log("numCorrect currently: ", numCorrect)
            console.log("incrementing number of correct answers by 1...")
            setNumCorrect(numCorrect + 1);
            console.log("numCorrect is now: ", numCorrect)
        }

        // checks if last question
        if (currentQuestion === orderOfSymbols.length - 1) {
            if (props.demo) {
                setCompleted(true)
                if (props.onCompletion) {
                    props.onCompletion()
                }
            } else {
                // Refresh ordering here
                setCurrentQuestion(0)
                setRound(round + 1)
                setOrderOfSymbols([])
                setFilledValues(Array(SPACES).fill(""))
            }
        }
        props.updateScore(numCorrect, round * SPACES + currentQuestion + 1, enteredText, answer)
    }

    let solutionTable = 
        <table className="symbol-table">
            <tr>
                {orderOfSymbols.map((num, index) => {
                    return <td {...tooltipProps} 
                                ref={index === currentQuestion ? node => { props.refs[0](node)} : null}
                                className={index === currentQuestion ? "selected" : ""}>
                                <i className={filledValues[index]}></i>
                           </td>
                })}
            </tr>
            <tr {...tooltipProps} ref={node => { props.refs[1](node)}}>
                {orderOfSymbols.map((index) => {
                    return <td>{index}</td>
                })}
            </tr>
        </table>


    let buttons = 
        <div className="symbol-buttons">
            {orderOfSymbols.map((num, index) => {
                return <button 
                            {...tooltipProps}
                            disabled={completed || props.tutorialOngoing} 
                            onClick={() => buttonOnClick(index)}
                            ref={index === 0 ? node => { props.refs[2](node)} : null}
                            >
                    <i className={symbols[index]}></i>
                </button>
            })}
        </div>
    

    return(
        <>
            {solutionTable}
            <br/><br/><br/><br/>
            {buttons}
        </>
    );
}